import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import FilterChip from "../filter-chip/FilterChip";
import { FiltersChipsNames } from "../../enums/FiltersChipsNames";
import StringHelper from "../../helpers/string.helper";
import { TipFilters } from "../../interfaces/TipFilters";
import {
  setTipsAuthors,
  setTipsDate,
  setTipsHasWords,
  setTipsTags,
} from "../../../store/filters/tipFilters.slice";

const TipFiltersChips = ({ filters }: { filters: TipFilters }) => {
  const dispatch = useDispatch();
  const deleteHandler = useCallback(
    (filterID: number, entity: FiltersChipsNames) => {
      switch (entity) {
        case FiltersChipsNames.TAG:
          dispatch(
            setTipsTags(filters.tags.filter((tag) => tag.id !== filterID))
          );
          break;
        case FiltersChipsNames.DATE:
          dispatch(setTipsDate(null));
          break;
        case FiltersChipsNames.KEYWORD:
          dispatch(setTipsHasWords(null));
          break;
        case FiltersChipsNames.AUTHOR:
          dispatch(
            setTipsAuthors(filters.authors.filter((author) => author.id !== filterID))
          );
          break;
        default:
          break;
      }
    },
    [dispatch, filters]
  );

  return (
    <Swiper
      spaceBetween={5}
      slidesPerView={"auto"}
      modules={[Navigation]}
      navigation
      className="pt-5 pb-2"
    >
      {filters.hasWords && (
        <SwiperSlide key="keywords-chip">
          <FilterChip
            id={Number(StringHelper.generateRandomString(8))}
            name={filters.hasWords}
            onDelete={deleteHandler}
            entity={FiltersChipsNames.KEYWORD}
          />
        </SwiperSlide>
      )}
      {filters.authors.map((author) => (
        <SwiperSlide key={`author-${author.id}`}>
          <FilterChip
            id={author.id}
            name={author.attributes.name}
            onDelete={deleteHandler}
            entity={FiltersChipsNames.AUTHOR}
          />
        </SwiperSlide>
      ))}
      {filters.tags.map((tag) => (
        <SwiperSlide key={tag.id}>
          <FilterChip
            id={tag.id}
            name={tag.attributes.name}
            onDelete={deleteHandler}
            entity={FiltersChipsNames.TAG}
          />
        </SwiperSlide>
      ))}
      {filters.date ? (
        <SwiperSlide>
          <FilterChip
            id={Number(StringHelper.generateRandomString(8))}
            name={filters.date.name}
            onDelete={deleteHandler}
            entity={FiltersChipsNames.DATE}
          />
        </SwiperSlide>
      ) : null}
    </Swiper>
  );
};

export default TipFiltersChips;
